(() => {
  function patchYotpoEmptyState() {
    const emptyReviewsPattern = /^0\s+reviews?$/i;
    const emptyReviewsTextPattern = /\b0\s+reviews?\b/i;
    const writeReviewPattern = /^write a review$/i;

    document.querySelectorAll('.card-product__yotpo').forEach(cardYotpo => {
      if (emptyReviewsTextPattern.test(cardYotpo.textContent)) {
        cardYotpo.style.display = 'none';
      } else {
        cardYotpo.style.display = '';
      }
    });

    document.querySelectorAll('.yotpo-sr-bottom-line-text--right-panel').forEach(countEl => {
      if (countEl.closest('.card-product__yotpo')) return;
      if (!emptyReviewsPattern.test(countEl.textContent.trim())) return;

      const rightPanel = countEl.closest('.yotpo-sr-bottom-line-right-panel');
      if (rightPanel) rightPanel.style.display = 'none';

      const widget = countEl.closest(
        '.yotpo-widget-instance, .yotpo-reviews-star-ratings-widget, .yotpo-sr-bottom-line-summary'
      );
      const borderScope = widget || rightPanel?.parentElement || document;
      borderScope.querySelectorAll('.yotpo-sr-vertical-border--new-review-btn').forEach(border => {
        border.style.display = 'none';
      });
    });

    document.querySelectorAll('.yotpo-sr-bottom-line-new-review').forEach(writeBtn => {
      if (writeBtn.closest('.card-product__yotpo')) return;

      if (writeReviewPattern.test(writeBtn.textContent.trim())) {
        writeBtn.textContent = 'Be the first to review';
      }
    });
  }

  function startYotpoEmptyStateObserver() {
    if (window.yotpoEmptyStateObserverStarted) {
      patchYotpoEmptyState();
      return;
    }

    window.yotpoEmptyStateObserverStarted = true;

    let isScheduled = false;

    const schedulePatch = () => {
      if (isScheduled) return;

      isScheduled = true;
      window.requestAnimationFrame(() => {
        patchYotpoEmptyState();
        isScheduled = false;
      });
    };

    schedulePatch();

    const observer = new MutationObserver(schedulePatch);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.body) {
    startYotpoEmptyStateObserver();
  } else {
    document.addEventListener('DOMContentLoaded', startYotpoEmptyStateObserver, { once: true });
  }
})();
